import React, {useEffect, useState} from "react";
import { useForm } from "react-hook-form";
import {Link, useNavigate} from 'react-router-dom';
import axios from 'axios';
import { useBaseUrlContext } from "../context/Base_url";
import { useAlertContext } from "../context/Alerts";
import {useUserContext} from "../context/User.js";

import {ThemeProvider, Container, Typography, FormControl, OutlinedInput, InputLabel, InputAdornment, IconButton } from '@mui/material';

import {ThemeCustom} from '../styles/Theme'

import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';

import signInImg from '../assets/sign-in-img.jpg'
import Logo from '../assets/Logo-rebrand-lg.svg'
import ButtonMain from "../components/button/Button_main";

const SignIn = () => {
    const {register, handleSubmit, formState: { errors },} = useForm();
    const navigate = useNavigate();
    const [showPassword, setShowPassword] = useState(false);
    const { baseUrl } = useBaseUrlContext();
    const { sucessAlert, failAlert } = useAlertContext();
    const {userTokenExtract} = useUserContext();

    //Password viewer

    const handleClickShowPassword = () => setShowPassword((show) => !show);
    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };

    //sign in 

    const onSubmit = (data) =>{
        console.log('submit', data);

        axios
        .post(`${baseUrl}/users/common/login`, data)
        .then((response) => {
            console.log('res', response);
            const res = response.data;
            if(res.code === 200){
                console.log('token', res,data)
                localStorage.setItem('token', res.data)
                navigate('/job-board')
                userTokenExtract(res.data)
            }
            else{
                console.error(res.message)
                failAlert(true, res.message)
            }
        })
        .catch((err) => {
            console.error('Internal Server Error', err)
            failAlert(true, 'Oops! Something went wrong. Please hang tight and try again in a moment.')
            
        })

    }

    return(
        <ThemeProvider theme={ThemeCustom}>
            <Container maxWidth='false' className="relative p-0" >
                <div className="flex items-center">
                    <div className="md:w-1/2 w-full p-20">
                        <div className="sign-in-container max-w-[30rem] mx-auto">
                            <img src={Logo} alt="TalentScout logo" className="w-full max-w-[25rem]"/>
                            <Typography component={'div'} variant="textheader1" className="mb-1 mt-14">Welcome!</Typography>
                            <Typography component={'div'} variant="text18Light">
                                Find your top talent faster than ever.        
                            </Typography>
                            <div className="formn-container mt-14">
                                <form onSubmit={handleSubmit(onSubmit)} >
                                    <FormControl fullWidth variant="standard">
                                        <div className="flex justify-between">
                                            <InputLabel shrink htmlFor="userEmail">Email</InputLabel>
                                            {errors.email && <span className="text-red font-medium text-sm">{errors.email.message}</span>}
                                        </div>
                                        <OutlinedInput
                                            id="userEmail"
                                            placeholder="Enter your email"
                                            type='email'
                                            {...register("email", { required: 'Email is required', pattern: {
                                                value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                                                message: 'Invalid email address'} 
                                            })}
                                        />
                                    </FormControl>
                                    <FormControl fullWidth variant="standard">
                                        <div className="flex justify-between">
                                            <InputLabel shrink htmlFor="userPassword">Password</InputLabel>
                                            {errors.password && <span className="text-red font-medium text-sm">Password is required</span>}
                                        </div>
                                        <OutlinedInput
                                            id="userPassword"
                                            placeholder="Enter your password"
                                            type={showPassword ? 'text' : 'password'}
                                            {...register("password", { required: true})}
                                            endAdornment={
                                            <InputAdornment position="end">
                                                <IconButton
                                                    aria-label="toggle password visibility"
                                                    onClick={handleClickShowPassword}
                                                    onMouseDown={handleMouseDownPassword}
                                                    edge="end"
                                                >
                                                {showPassword ? <VisibilityOff /> : <Visibility />}
                                                </IconButton>
                                            </InputAdornment>
                                            }
                                        />
                                    </FormControl>
                                    <Typography component={'div'} className="mb-6 cursor-not-allowed" align="right" variant="textBaseSecondary">Forgot Password?</Typography> 
                                    <ButtonMain 
                                        variant='secondary' 
                                        type='submit' 
                                        disabled={false} 
                                        name='Sign in'
                                        class='w-full capitalize'
                                    />
                                </form>
                            </div>
                        </div>
                    </div>
                    <div className="md:w-1/2 w-full">
                        <img src={signInImg} alt="A girl is calling" className="w-full object-cover block h-screen"/>
                    </div>
                </div>
            </Container>
        </ThemeProvider>    
    )
}

export default SignIn;